/*********************** Custom JS for Boost AI Search & Discovery  ************************/

// Start boost 216939  
let customSettingsForRecommendationWidget = {
    "productItems": {
        "general": {
            "borderLayout": "hasPadding",
            "backgroundColor": "rgba(255, 255, 255, 1)",
            "backgroundColorOnHover": "rgba(255, 255, 255, 1)",
            "borderColor": "rgba(128, 128, 128, 0.16)",
            "borderColorOnHover": "rgba(128, 128, 128, 0.2)"
        },
        "productImg": {
            "elements": {
                "productSaleLabel": {
                    "shape": "rectangle",
                    "displayType": "text",
                    "color": "rgba(255, 255, 255, 1)",
                    "backgroundColor": "rgba(240, 79, 54, 1)"
                },
                "productSoldOutLabel": {
                    "hideOtherLabelsWhenSoldOut": true,
                    "shape": "rectangle",
                    "displayType": "text",
                    "color": "rgba(255, 255, 255, 1)",
                    "backgroundColor": "rgba(29, 29, 29, 1)"
                }
            },
            "grid": {
                "bottom": {
                    "direction": "horizontal",
                    "elements": {
                        "left": [
                            "saleLabel",
                            "soldOutLabel"
                        ]
                    }
                }
            },
            "aspectRatioType": "natural",
            "hoverEffect": "reveal-second-image"
        },
        "productInfo": {
            "textAlign": "left",
            "elements": {                
                "vendor": {
                    "color": "rgba(148, 148, 148, 1)",
                    "fontFamily": "Poppins, sans-serif",
                    "fontStyle": "normal",
                    "fontSize": 15,
                    "textTransform": "capitalize",
                    "fontWeight": 400
                },
                "title": {
                    "color": "rgba(29, 29, 29, 1)",
                    "fontFamily": "Poppins, sans-serif",
                    "fontStyle": "normal",
                    "fontSize": 15,
                    "textTransform": "capitalize",
                    "fontWeight": 400
                },
                "price": {
                    "showCentAsSuperscript": false,
                    "showCurrencyCodes": false,
                    "showMultiVariantPrice": "{{minPrice}} - {{maxPrice}}",
                    "priceColor": "rgb(0, 0, 0)",
                    "priceFontFamily": "Poppins, sans-serif",
                    "priceFontStyle": "normal",
                    "priceFontSize": 14,
                    "salePriceColor": "rgb(0, 0, 0)",
                    "salePriceFontFamily": "Poppins, sans-serif",
                    "salePriceFontStyle": "normal",
                    "salePriceFontSize": 14,
                    "compareAtPriceColor": "rgba(148, 148, 148, 1)",
                    "compareAtPricePosition": "top",
                    "compareAtPriceFontFamily": "Poppins, sans-serif",
                    "compareAtPriceFontStyle": "normal",
                    "compareAtPriceFontSize": 14,
                    "showSavingDisplay": false,
                    "savingDisplayColor": "rgba(255, 51, 0, 1)",
                    "priceFontWeight": 400,
                    "salePriceFontWeight": 400,
                    "compareAtPriceFontWeight": 400
                },
                "inventoryStatus": {
                    "lowInventoryThreshold": 5,
                    "textTransform": "none",
                    "inStockColor": "rgba(60, 147, 66, 1)",
                    "lowStockColor": "rgba(233, 145, 20, 1)",
                    "soldOutColor": "rgba(191, 38, 47, 1)",
                    "fontFamily": "Nunito Sans",
                    "fontStyle": "normal",
                    "fontSize": 14,
                    "fontWeight": 400
                },
                "selectOptionBtn": {
                    "buttonType": "selectOptionBtn",
                    "showOnHovering": true,
                    "showOn": "desktopAndMobile",
                    "action": "popup",
                    "displayType": "text",
                    "shape": "rectangle",
                    "imgSrc": "https://boost-cdn-prod.bc-solutions.net/icon/add-to-cart-white.svg",
                    "iconPosition": "left",
                    "backgroundColor": "rgba(240, 79, 54, 1)",
                    "backgroundColorOnHover": "rgba(242, 97, 74, 1)",
                    "borderColor": "rgba(240, 79, 54, 1)",
                    "borderColorOnHover": "rgba(242, 97, 74, 1)",
                    "textColor": "rgba(255, 255, 255, 1)",
                    "textColorOnHover": "rgba(255, 255, 255, 1)",
                    "textTransform": "none",
                    "alignment": "right",
                    "fontFamily": "Nunito Sans",
                    "fontStyle": "normal",
                    "fontSize": 14,
                    "fontWeight": null,
                    "width": "50%"
                },
                "qvBtn": {
                    "buttonType": "qvBtn",
                    "showOnHovering": true,
                    "showOn": "desktopAndMobile",
                    "displayType": "text",
                    "shape": "rectangle",
                    "imgSrc": "https://boost-cdn-prod.bc-solutions.net/icon/quick-view.svg",
                    "iconPosition": "left",
                    "backgroundColor": "rgba(255, 255, 255, 1)",
                    "backgroundColorOnHover": "rgba(255, 255, 255, 1)",
                    "borderColor": "rgba(221, 221, 221, 1)",
                    "borderColorOnHover": "rgba(206, 206, 206, 1)",
                    "textColor": "rgba(240, 79, 54, 1)",
                    "textColorOnHover": "rgba(240, 79, 54, 1)",
                    "textTransform": "none",
                    "alignment": "left",
                    "fontFamily": "Nunito Sans",
                    "fontStyle": "normal",
                    "fontSize": 14,
                    "fontWeight": null,
                    "width": "50%"
                }
            }
        }
    },
    "additionalElements": {
        "pagination": {
            "paginationType": "default",
            "alignment": "center",
            "textDescription": "Showing {{from}} - {{to}} of {{total}} products",
            "productCount": {
                "showProductCount": false,
                "position": "top"
            },
            "number": {
                "shape": "square",
                "color": "rgba(4, 110, 130, 1)",
                "colorOnSelected": "rgba(29, 29, 29, 1)",
                "backgroundColor": "rgba(0, 0, 0, 0)",
                "backgroundColorOnSelected": "rgba(0, 0, 0, 0)",
                "fontFamily": "Nunito Sans",
                "fontStyle": "normal",
                "fontSize": 16,
                "fontWeight": 400
            },
            "button": {
                "shape": "square",
                "buttonType": "text-with-icon",
                "color": "rgba(4, 110, 130, 1)",
                "backgroundColor": "rgba(0, 0, 0, 0)",
                "backgroundColorOnHover": "rgba(0, 0, 0, 0)",
                "textTransform": "capitalize",
                "fontFamily": "Nunito Sans",
                "fontStyle": "normal",
                "fontSize": 16,
                "fontWeight": 400
            }
        },
        "toolbar": {
            "layout": "2_1",
            "elements": {
                "sorting": {},
                "viewAs": {
                    "listType": "grid/list"
                }
            }
        },
        "collectionHeader": {
            "layout": 3,
            "contentPosition": "middle-left",
            "backgroundColor": "rgba(0, 0, 0, 0)",
            "isHidden": false,
            "elements": {
                "breadCrumb": {
                    "showCollectionList": false,
                    "showCollectionTitle": true,
                    "showPagination": false,
                    "placement": "on-top",
                    "alignment": "middle-left"
                },
                "collectionImage": {
                    "size": "original",
                    "parallaxEffect": false,
                    "directionParallax": "vertical",
                    "overlayColor": "rgba(0, 0, 0, 0)"
                },
                "collectionTitle": {
                    "textAlign": "left",
                    "textTransform": "none",
                    "fontFamily": "Montserrat",
                    "fontStyle": "normal",
                    "collectionTitleColor": "rgba(29, 29, 29, 1)",
                    "fontSize": 34,
                    "fontWeight": 800
                },
                "collectionDescription": {}
            }
        }
    },
    "quickView": {
        "showProductImage": true,
        "thumbnailPosition": "bottomCenter",
        "buttonOverall": {
            "shape": "rectangle",
            "fontFamily": "Nunito Sans",
            "fontStyle": "normal",
            "fontSize": 18,
            "fontWeight": 700
        },
        "buyItNowBtn": {
            "enable": true,
            "color": "rgba(255, 255, 255, 1)",
            "hoverColor": "rgba(255, 255, 255, 1)",
            "backgroundColor": "rgba(240, 79, 54, 1)",
            "hoverBackgroundColor": "rgba(242, 97, 74, 1)",
            "borderColor": "rgba(240, 79, 54, 1)",
            "hoverBorderColor": "rgba(242, 97, 74, 1)",
            "textTransform": "capitalize"
        },
        "addToCartBtn": {
            "color": "rgba(240, 79, 54, 1)",
            "hoverColor": "rgba(240, 79, 54, 1)",
            "backgroundColor": "rgba(255, 255, 255, 1)",
            "hoverBackgroundColor": "rgba(255, 255, 255, 1)",
            "borderColor": "rgba(221, 221, 221, 1)",
            "hoverBorderColor": "rgba(206, 206, 206, 1)",
            "textTransform": "capitalize"
        }
    },
    "cart": {
        "enableCart": true,
        "cartStyle": "none",
        "generalLayout": {
            "shape": "round",
            "fontFamily": "Nunito Sans",
            "fontStyle": "normal",
            "fontSize": 18,
            "fontWeight": 700
        },
        "checkoutBtn": {
            "textTransform": "capitalize",
            "color": "rgba(255, 255, 255, 1)",
            "hoverColor": "rgba(255, 255, 255, 1)",
            "backgroundColor": "rgba(240, 79, 54, 1)",
            "hoverBackgroundColor": "rgba(242, 97, 74, 1)",
            "borderColor": "rgba(240, 79, 54, 1)",
            "hoverBorderColor": "rgba(242, 97, 74, 1)"
        },
        "viewCartBtn": {
            "textTransform": "capitalize",
            "color": "rgba(240, 79, 54, 1)",
            "hoverColor": "rgba(240, 79, 54, 1)",
            "backgroundColor": "rgba(255, 255, 255, 1)",
            "hoverBackgroundColor": "rgba(255, 255, 255, 1)",
            "borderColor": "rgba(221, 221, 221, 1)",
            "hoverBorderColor": "rgba(206, 206, 206, 1)"
        }
    },
    "productList": {
        "productsPerPage": 24,
        "productsPerRowOnDesktop": 4,
        "productsPerRowOnMobile": 2
    }
}


if (boostSDAppConfig?.themeSettings) {
     boostSDAppConfig.themeSettings = {...boostSDAppConfig.themeSettings, ...customSettingsForRecommendationWidget};
}
// End boost 216939  

let formatMoneyHelper = '';
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {

        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
    }
]);

const customize = {   
    updateRecommendation: (registry) => {      
        let formatMoneyHelper = '';
        registry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
        registry.useModulePlugin('RecommendationAPI', {         
            name: 'Customize Recommendation',         
            apply(builder) {            
                builder.on('methodFulfilled', 'get', (result) => {               
                let recommendationProducts = result.result.products;               
                if (recommendationProducts.length > 0) {                  
                    for (let i = 0; i < recommendationProducts.length; i++) {                     
                        setTimeout(function() {                        
                            let productItems = document.querySelectorAll(`.boost-sd__recommendation .boost-sd__product-item[data-product-id="` + recommendationProducts[i].id + `"]`);                        
                            productItems.forEach(function(productItem) {                           
                                const productData = recommendationProducts[i];                    
                                if (productData.title) {
                                    const newTitle = productData.title.replace(productData.vendor, '');
                                    productItem.querySelector('.boost-sd__product-title').innerHTML = newTitle;    
                                }     
                                // Price
                                if (productItem.querySelector('.boost-sd__product-price-content')) {
                                    let price = productData.price_min;
                                    let compare_at_price = productData.compare_at_price_min;
                                    const priceStyle = 'color: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceColor +
                                                        '; font-size: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontSize + 'px' +
                                                        '; font-family: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontFamily +
                                                        '; font-weight: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontWeight +
                                                        '; font-style: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontStyle;
                                    const comparePriceStyle = 'color: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.compareAtPriceColor +
                                                            '; font-size: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.compareAtPriceFontSize + 'px' +
                                                            '; font-family: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.compareAtPriceFontFamily +
                                                            '; font-weight: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.compareAtPriceFontWeight +
                                                            '; font-style: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.compareAtPriceFontStyle;
                                    if (compare_at_price > price) {
                                        let priceHtml = '<div class="boost-sd__product-price-content boost-sd__product-price-content--text-align-left">' +
                                                            '<span class="boost-sd__format-currency boost-sd__format-currency--price-sale">' +
                                                                '<span style="' + priceStyle + '" class="">' + formatMoneyHelper(Number(price), window.boostSDAppConfig?.shop?.money_format, true) + '</span>' + 
                                                            '</span>' +
                                                        '</div>';
                                        let comparePriceHtml = '<div class="boost-sd__product-price-compare">' + 
                                                                    '<span class="boost-sd__format-currency boost-sd__format-currency--price-compare">' +
                                                                        '<span style="' + comparePriceStyle + '" class="">' + formatMoneyHelper(Number(compare_at_price), window.boostSDAppConfig?.shop?.money_format, true) + '</span>' +
                                                                    '</span>' +
                                                                '</div>';
                                        productItem.querySelector('.boost-sd__product-price-content').innerHTML = priceHtml + comparePriceHtml;
                                    } else {
                                        let priceHtml = '<span class="boost-sd__format-currency" style="' + priceStyle + '">';
                                        if (productData.price_min != productData.price_max) {
                                            priceHtml += boostSDAppConfig.translation.productItem.amount;
                                        } else {
                                            priceHtml += '<span>{{minPrice}}</span>';
                                        }
                                        priceHtml += '</span>';
                                        priceHtml = priceHtml.replace(/{{minPrice}}/g, formatMoneyHelper(Number(productData.price_min), window.boostSDAppConfig?.shop?.money_format, true));
                                        productItem.querySelector('.boost-sd__product-price-content').innerHTML = priceHtml;
                                    }
                                }                
                            });                     
                        }, 500);                  
                    }               
                }            
                });         
            }      
        });   
    },
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateRecommendation]);